document.querySelectorAll('[data-open-modal]').forEach(btn => {
  btn.addEventListener('click', () => {
    const targetId = btn.dataset.openModal;
    const modal = document.querySelector(`.modal[data-modal-id="${targetId}"]`);
    if (!modal) return;
    openModal(modal, btn);
  });
});

document.querySelectorAll('[data-close-modal]').forEach(btn => {
  btn.addEventListener('click', () => {
    const modal = btn.closest('.modal');
    if (modal) closeModal(modal);
  });
});

function openModal(modal, triggerEl) {
  const targetId = modal.dataset.modalId;
  document.body.classList.add('modal-' + targetId + '--open');
  modal.setAttribute('aria-hidden', 'false');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.classList.remove('hidden');
  modal._triggerElement = triggerEl;

  const focusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (focusable) focusable.focus();

  modal._keyHandler = (e) => {
    if (e.key === 'Escape') {
      closeModal(modal);
      return;
    }
    if (e.key === 'Tab') {
      trapFocus(modal, e);
    }
  };
  document.addEventListener('keydown', modal._keyHandler);
}

function closeModal(modal) {
  const targetId = modal.dataset.modalId;
  document.body.classList.remove('modal-' + targetId + '--open');
  modal.setAttribute('aria-hidden', 'true');

  if (modal._keyHandler) {
    document.removeEventListener('keydown', modal._keyHandler);
    modal._keyHandler = null;
  }

  if (modal._triggerElement) {
    modal._triggerElement.focus();
    modal._triggerElement = null;
  }
}

function trapFocus(modal, e) {
  const focusableEls = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (!focusableEls.length) return;
  const firstEl = focusableEls[0];
  const lastEl = focusableEls[focusableEls.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === firstEl) {
      e.preventDefault();
      lastEl.focus();
    }
  } else {
    if (document.activeElement === lastEl) {
      e.preventDefault();
      firstEl.focus();
    }
  }
}
